import React from 'react';
import Container from 'container';
import Headline from 'headline';
import Button from 'button';
import s from './lp_buttons.module.scss';

export default function LpButtons({
  title,
  buttons
}) {
  return (
    <Container>
      <div className={s.wrapper}>
        <Headline className={s.title} h2 center black html={title} />

        <div className={s.buttonsWrapper}>
          {
            buttons.map(({ button }) => (
              <Button className={s.button} key={button.title} small href={button.url}>
                {button.title}
              </Button>
            ))
          }
        </div>
      </div>
    </Container>
  );
}
